import React from 'react';
import Revoke_FW from './Revoke_FW';
import '../../../CommonCSS/SocietyCSS.css'

const Revoke_FWApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Revoke Fees Waiver</h5>
          </div>  
        </div>
        <Revoke_FW/>
      </div>
    </div >
  );
};

export default Revoke_FWApp;
